module.exports = "<app-simple-table [dataService]=\"dataService\" [columnList]=\"columnList\"></app-simple-table>\n"